// extracted by mini-css-extract-plugin
export default {"styles":"styles___nfnw6"};